import React from 'react'
import Link from 'gatsby-link'

import Divider from '../images/Divider.svg'

const terms = () => (
  <section>
    <article className="container">
      <div>
        <h1 className='smallerHone'>Privacy Policy</h1>
        <img src={Divider} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
        <p>
          <span className='smallerHone gradient'>Nisadhya Digital Marketing Pvt. Ltd.</span><br/>
          Lazimpat -3, Kathmandu<br/>
          Nepal 44600
        </p>
        <p>
          contact@nisadhya.com<br/>
          +977 01-4433084
        </p>
      </div>
      <div>
          <p><strong>Accountability For Content</strong><br/>
          The contents of Nisadhya’s pages have been created with the utmost care.
          However, we cannot guarantee the contents' accuracy, completeness or topicality. According to statutory provisions,
          we're furthermore responsible for our own content on these web pages. In this context, please note that we're accordingly not obliged
          to monitor merely the transmitted or saved information of third parties, or investigate circumstances pointing to illegal activity.</p>
      </div>
      <div>
          <p><strong>Accountability For Links</strong><br/>
          Responsibility for the content of external links (to web pages of third parties) lies solely with the
          operators of the linked pages. No violations were evident to me at the time of linking.
          Should any legal infringement become known to us, we will remove the respective link immediately.</p>
          <p>Copyright Nisadhya’s web pages and their contents are subject to Nepal copyright law.
          Unless expressly permitted by law, every form of utilizing, reproducing or processing works subject to
          copyright protection on our web pages requires the prior consent of the respective owner of the rights.
          Unauthorized utilization of copyrighted works is punishable.</p>
      </div>
      <div>
          <p><strong>Google Analytics</strong><br/>
          This website uses Google Analytics, a web analytics service provided by Google, Inc. (“Google”).
          Google Analytics uses “cookies”, which are text files placed on your computer, to help the website analyze how users use the site.
          The information generated by the cookie about your use of the website (including your IP address)
          will be transmitted to and stored by Google on servers in the United States.</p>
          <p>In case of activation of the IP anonymization, Google will truncate/anonymize the last octet of the IP address for Member States
          of the European Union as well as for other parties to the Agreement on the European Economic Area.
          Only in exceptional cases, the full IP address is sent to and shortened by Google servers in the USA.</p>
          <p>On behalf of the website provider Google will use this information for the purpose of evaluating your use of the website, compiling
          reports on website activity for website operators and providing other services relating to website activity and internet usage to the website provider.
          Google will not associate your IP address with any other data held by Google. You may refuse the use of cookies by selecting the appropriate settings on your browser.</p>
          <p style={{marginBottom:'0'}}>However, please note that if you do this, you may not be able to use the full functionality of this website.
          Furthermore you can prevent Google’s collection and use of data (cookies and IP address) by downloading and installing the
          browser plug-in available under <a href="https://tools.google.com/dlpage/gaoptout?hl=en-GB" rel="nofollow" target="_blank" className='slide'>https://tools.google.com/dlpage/gaoptout?hl=en-GB</a>.</p>
        </div>
    </article>
  </section>
)

export default terms



// WEBPACK FOOTER //
// ./src/pages/privacy-policy.js